import React, { useState, useEffect } from 'react';
import { DataTable, PageWrapper } from '../../components';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../../shared/enums';
import { useTranslation } from 'react-i18next';
import { getVideoList } from '../../api/video';
import dayjs from 'dayjs';
import { DATETIME_FORMAT } from '../../shared/constants';
import { RiAddLargeLine } from 'react-icons/ri';
import Button from '../../components/common/Button';

const Video = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
    const [totalPages, setTotalPage] = useState(0);
    const [data, setData] = useState([]);

    const columns = [
        { key: "title", label: t("TITLE"), },
        { key: "fileName", label: t("FILE_NAME"), },
        { key: "description", label: t("DESCRIPTION"), },
        { key: "isPublish", label: t("IS_PUBLISH"), render: (v, data) => data.isPublish.toString(), },
        { key: "sequence", label: t("SEQUENCE"), },
        { key: "createdAt", label: t("CREATED_AT"), render: (createdAt, data) => dayjs(createdAt).format(DATETIME_FORMAT), },
        {
            key: "action", label: t("ACTION"), render: (v, data) => <Dropdown>
                <Dropdown.Toggle variant="primary" size="sm" className='py-0'></Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigate(Pages.VideoDetail.replace(":id", data.id))}>{t("EDIT")}</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        }
    ]

    useEffect(() => {
        getData(pagination)
    }, [pagination])

    const getData = async (pagination) => {
        const response = await getVideoList({ skip: (pagination?.page - 1) * pagination?.pageSize, limit: pagination?.pageSize })
        setData(response.items)
        setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize))
    }

    return (
        <PageWrapper
            headerProps={{
                title: "VIDEO",
                rightElement: <Button icon={<RiAddLargeLine />} onClick={() => navigate(Pages.VideoDetail.replace(":id", "new"))}>{t("ADD")}</Button>
            }}
        >
            <DataTable columns={columns} data={data} pagination={{ ...pagination, totalPages, onChange: setPagination }} />
        </PageWrapper>
    );
};

export default Video;
